/**
 * Format the prorated period for display and get remaining months/years
 * @param {object} proratedPeriod - { startAt: string, paymentPeriod: 'upfront'|'paymentPlan' }
 * @returns {object} { display, endsAt, remainingMonths }
 */
export function formatProratedPeriod(proratedPeriod) {
    if (!proratedPeriod || !proratedPeriod.startAt) return null;

    const startDate = new Date(proratedPeriod.startAt);
    let endDate = new Date(startDate);
    let unit = "";
    let remainingMonths = 0;

    if (proratedPeriod.paymentPeriod === "paymentPlan") {
        // Monthly: 1 month period
        endDate.setMonth(endDate.getMonth() + 1);
        unit = "month";
        remainingMonths = 1;
    } else {
        // Upfront / yearly
        endDate.setFullYear(endDate.getFullYear() + 1);
        unit = "year";
        // Calculate remaining months from today until endDate
        const now = new Date();
        remainingMonths = (endDate.getFullYear() - now.getFullYear()) * 12 + (endDate.getMonth() - now.getMonth());
        if (now.getDate() > endDate.getDate()) remainingMonths -= 1;
        if (remainingMonths <= 0) remainingMonths = 12; // fallback for same-day start
    }

    let display = "";
    if (unit === "month") {
        display = `${remainingMonths} month${remainingMonths > 1 ? "s" : ""} remaining`;
    } else {
        const years = Math.ceil(remainingMonths / 12);
        display = `${years} year${years > 1 ? "s" : ""} remaining`;
    }
    const paymentMode = proratedPeriod.paymentPeriod === "paymentPlan" ? "Monthly" : "Yearly";

    return {
        startAt: startDate.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }),
        endsAt: endDate.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }),
        display,
        remainingMonths,
        paymentMode
    };
}